// extracted by mini-css-extract-plugin
export default {"logo":"Navbar_logo__3H5Zh","nav_routes":"Navbar_nav_routes__yNQ31","nav_extra":"Navbar_nav_extra__B8rs0","nav_logo":"Navbar_nav_logo__+tw+f"};